import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import _sfc_main$1 from "./control_selection.vue.js";
import { UNSET, controlMap, getControlByValue } from "../../lib/control.js";
import { computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createVNode, mergeProps, normalizeClass, openBlock, ref, renderSlot, resolveDynamicComponent } from "vue";
//#region src/components/controls/control_dynamic.vue
var _hoisted_1 = { "data-qa": "dtc-control-dynamic-selection" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlDynamic" }, {
	props: {
		value: {
			type: void 0,
			default: () => UNSET
		},
		disabled: {
			type: Boolean,
			default: false
		},
		inputClass: {
			type: String,
			default: ""
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const bindings = computed(() => {
			return { disabled: props.disabled };
		});
		/**
		* Controls from the 'control map' to include in selections.
		*
		* @type {Array}
		*/
		const externalControls = [
			"string",
			"number",
			"array",
			"object"
		];
		const controlSelectionMap = {
			...Object.fromEntries(Object.entries(controlMap).filter(([controlName]) => {
				return externalControls.includes(controlName);
			})),
			true: {
				component: null,
				default() {
					return true;
				}
			},
			false: {
				component: null,
				default() {
					return false;
				}
			},
			null: {
				component: null,
				default() {
					return null;
				}
			},
			undefined: {
				component: null,
				default() {
					return UNSET;
				}
			}
		};
		const controlSelections = computed(() => Object.keys(controlSelectionMap));
		const selectedControl = ref(getControl());
		const controlComponent = computed(() => {
			return controlSelectionMap[selectedControl.value].component;
		});
		function getControl() {
			const value = props.value;
			switch (value) {
				case UNSET: return "undefined";
				case null: return "null";
				case false: return "false";
				case true: return "true";
			}
			const control = getControlByValue(value);
			return control === "base" ? controlMap.dynamic.defaultControl() : control;
		}
		function updateControl(e) {
			selectedControl.value = e;
			updateValue(controlSelectionMap[e].default());
		}
		function updateValue(e) {
			emit(VALUE_UPDATE_EVENT, e);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", null, [
				renderSlot(_ctx.$slots, "default"),
				createElementVNode("div", _hoisted_1, [createVNode(_sfc_main$1, {
					value: selectedControl.value,
					"valid-values": controlSelections.value,
					disabled: __props.disabled,
					"onUpdate:value": updateControl
				}, null, 8, [
					"value",
					"valid-values",
					"disabled"
				])]),
				createElementVNode("div", {
					class: normalizeClass(["d-ps-relative d-b1", __props.inputClass]),
					"data-qa": "dtc-control-dynamic-value"
				}, [controlComponent.value ? (openBlock(), createBlock(resolveDynamicComponent(controlComponent.value), mergeProps({ key: 0 }, bindings.value, {
					value: __props.value,
					"onUpdate:value": updateValue
				}), null, 16, ["value"])) : createCommentVNode("", true)], 2)
			]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_dynamic.vue.js.map